"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domReady = exports.readyToAnimate = exports.removeClass = exports.addClass = exports.hasClass = exports.getOffset = exports.existDomEl = exports.exist = exports.selectAll = exports.select = void 0;
/**
 *
 * @param el
 * @returns dom element
 */
var select = function select(el) {
    return document.querySelector(el);
};
exports.select = select;
/**
 *
 * @param el
 * @returns Node list
 */
var selectAll = function selectAll(el) {
    return document.querySelectorAll(el);
};
exports.selectAll = selectAll;
/**
 *
 * @param el
 * @returns boolean
 */
var exist = function exist(el) {
    return typeof (0, exports.select)(el) !== 'undefined' && (0, exports.select)(el) !== null;
};
exports.exist = exist;
/**
 *
 * @param el
 * @returns boolean
 */
var existDomEl = function existDomEl(el) {
    return typeof el !== 'undefined' && el !== null;
};
exports.existDomEl = existDomEl;
/**
 *
 * @param el
 * @returns Elements top & left offset
 */
var getOffset = function getOffset(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
};
exports.getOffset = getOffset;
/**
 *
 * @param el
 * @param className
 * @returns boolean
 */
var hasClass = function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : el.className.includes(className);
};
exports.hasClass = hasClass;
/**
 *
 * @param el
 * @param className
 */
var addClass = function addClass(el, className) {
    if (el.classList)
        el.classList.add(className);
    else if (!(0, exports.hasClass)(el, className))
        el.className += ' ' + className;
};
exports.addClass = addClass;
/**
 *
 * @param el
 * @param className
 */
var removeClass = function removeClass(el, className) {
    if (el.classList)
        el.classList.remove(className);
    else if ((0, exports.hasClass)(el, className)) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ');
    }
};
exports.removeClass = removeClass;
var readyToAnimate = function readyToAnimate(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
    return vertInView && horInView;
};
exports.readyToAnimate = readyToAnimate;
var domReady = function domReady(callback) {
    if (typeof document === 'undefined') {
        return;
    }
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        return void callback();
    }
    document.addEventListener('DOMContentLoaded', callback);
};
exports.domReady = domReady;
